import React, {useState, useEffect} from 'react';
import { Row, Col, Form, Tabs, Tab } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import StackedbarChart from '../charts/StackedbarChart';
import MultiLineChart from '../charts/MultiLineChart';
import { MeasurementController } from "../../../controllers/MeasurementController";
import moment from 'moment';
import { history } from '../../../state/store';
import { getMapLayerOptions, setAllLoadedLayers, updateLoadedDynamicCadastreLayers } from '../../../state/reducers/ui';
import { getUserCadastreData } from '../../../state/reducers/user';

import connect from 'react-redux/es/connect/connect';

function EnvironmentDetails(props) {


    const [activeId, setActiveId] = useState('10'); // eslint-disable-line
    const [group, setGroup] = useState(false);

    //Humidity
    const [currentHumidity, setCurrentHumidity] = useState("N/A");
    const [, setPreviousHumData] = useState([]);
    const [humidityataLast5Days, setHumidityDataLast5Days] = useState([]);
    const [humidityParse, setHumidityParse] = useState([]);

    //Dust
    const [dustDataLast5Days, setDustDataLast5Days] = useState([]);
    const [dustParse, setDustParse] = useState([]);

    const [dustThreshold, setDustTreshold] = useState(0);
    const [dustLimitPrevMonth, ] = useState([]);

    //Temperature
    const [temperatureDataActual, setTemperatureDataActual] = useState(0);
    const [temperatureDataLastDay, setTemperatureDataLastDay] = useState({min:0, max:0, avg:0});
    const [temperatureDataLast5Days, setTemperatureDataLast5Days] = useState([]);
    const [temperatureParse, setTemperatureParse] = useState([]);

    const [dataDevice,setDataDevice] = useState([]);
    const [selectedDevice, setSelectedDevice] = useState(false);

    const [dustWeeklyAvg, ] = useState({min:0, max:0, avg:0});

    const [lastMeasurement, setLastMeasurement] = useState({humidity:"Nincs adat", dust:"Nincs adat", temperature:"Nincs adat"});

    const MeasurementControllerInst = MeasurementController.getInstance();

    const [dateType, setDateType] = useState(7);

    //Measurementall
    const [coData, setCoData] = useState(false);
    const [noiseData, setNoiseData] = useState(false);

    function openCadastreOnMap() {

        let cadastre = props.cadastreData[70];

        if(!props.layerOptions.allLoadedLayers.includes(cadastre.cadastre_id)) {
            if(cadastre.data_source !== 'static') {
                props.updateLoadedDynamicCadastreLayers(cadastre)
                history.push('/map');
            }else {
                props.setLoadedCadastreLayers({name:cadastre.cadastre_ref, cadastre_id:cadastre.cadastre_id});
                history.push('/map');
            }
            props.addLayer(cadastre.cadastre_id);
        }else {
            history.push("/map")
        }
    }

    useEffect(() => {
        getStatistics()
        if(!dataDevice.length) {
            MeasurementControllerInst.getDevices().then(response =>{
                setDataDevice(response.data)
            })
        }
    }, [selectedDevice, dateType]) // eslint-disable-line react-hooks/exhaustive-deps

    function getStatistics() {
        let endDate = moment().format("YYYY-MM-DD");
        let startDate = moment().subtract(dateType, "days").format("YYYY-MM-DD")

        MeasurementControllerInst.getHumidityStatistics(startDate, endDate, selectedDevice).then(response => {
            setHumidityParse([]);

            if(response.statusCode === 200) {
                setCurrentHumidity(response.data.humidity.actual);
                setPreviousHumData(response.data.humidity.previous_day);
                setLastMeasurement(prevState => ({
                    ...prevState,
                    humidity: response.data.humidity.last_measurement
                }));

                let temp = [];
                let parse = []

                Object.keys(response.data.humidity.days).forEach(date => {
                    parse.push(date);
                    temp.push(response.data.humidity.days[date]);
                });

                setHumidityDataLast5Days(temp);
                setHumidityParse(parse);
            }
        });

        MeasurementControllerInst.getDustStatistics(startDate, endDate, selectedDevice).then(response => {
            setDustDataLast5Days([]);
            setDustParse([]);
            if(response.statusCode === 200) {
                setLastMeasurement(prevState => ({
                    ...prevState,
                    dust: response.data.last_measurement
                }));

                setDustTreshold(response.data.threshold);
                let temp = [];
                let parse = []

                Object.keys(response.data.data).forEach( date => {
                    Object.keys(response.data.data[date]).forEach( time  => {
                        temp.push(response.data.data[date][time]);

                        if(dateType === 1) {
                            parse.push(time);
                        }else {
                            parse.push(date);
                        }
                    })
                });

                setDustDataLast5Days(temp);
                setDustParse(parse);
            }
        });

        MeasurementControllerInst.getTemperature(selectedDevice, startDate, endDate).then(response => {
            setTemperatureDataLast5Days([]);
            setTemperatureParse([]);
            if(response.statusCode === 200) {
                setLastMeasurement(prevState => ({
                    ...prevState,
                    temperature: response.data.last_measurement
                }));

                setTemperatureDataActual(response.data.actual)
                setTemperatureDataLastDay(response.data.previous_day);

                let temp = [];
                let parse = []

                Object.keys(response.data.data).forEach( date => {
                    Object.keys(response.data.data[date]).forEach( time  => {
                        temp.push(response.data.data[date][time]);

                        if(dateType === 1) {
                            parse.push(time);
                        }else {
                            parse.push(date);
                        }
                    })
                });

                setTemperatureDataLast5Days(temp);
                setTemperatureParse(parse);
            }
        });

        MeasurementControllerInst.getCOSummary(startDate, endDate, selectedDevice).then(response => {
            setCoData(response.data);
        });

        MeasurementControllerInst.getNoiseSummary(startDate, endDate, selectedDevice).then(response => {
            setNoiseData(response.data);
        });
    };

    useEffect(() => {
        if(group === 'false') {
            setSelectedDevice(false);
        }else if(dataDevice && group) {
            setSelectedDevice(dataDevice[group][0])
        }
    }, [group]) // eslint-disable-line react-hooks/exhaustive-deps

    function rendeDevices() {
        if(group && group !== 'false') {
            return dataDevice[group].map(e => {
                return(
                    <option key={e} value={e}>{e}</option>
                )
            })    
        }else {
            return(
                <option key={'Átlag'} value="false">Átlag</option>
            )
        }
    }

    const weeklyParse = ["1.hét", "2.hét", "3.hét", "4.hét"];
    const yearlyParse = ["2018", "2019", "2020"];

    //TEMP
    const monthlyParse = ["Jan", "Feb", "Már", "Ápr", "Máj", "Jun", "Júl", "Aug", "Szep", "Okt", "Nov", "Dec"];

    return(
        <div>
            <Form.Group controlId="ControlSelect" className="widget-device-selecter">
                <Row style={{height:'auto'}}><Form.Label style={{fontWeight: 'bold',padding: '2px', margin: '2px'}}>Eszköz kiválasztása </Form.Label></Row>
                <Row style={{padding: '5px 0', margin: '0', border: '10px'}}>
                    <Form.Control size="sm" as="select" style={{marginRight:'2px'}} onChange={(event) => { setGroup(event.target.value) }}>
                            <option value="false">Átlag</option>
                            { Object.keys(dataDevice).map(e => {
                                return(
                                    <option key={e} value={e}>{e}</option>
                                    )})                            
                                } 
                    </Form.Control>
                    <Form.Control size="sm" as="select" onChange={(event) => { setSelectedDevice(event.target.value)} }>
                            {rendeDevices()}
                    </Form.Control>
                </Row>
            </Form.Group>

            <Tabs defaultActiveKey={props.value}>
                <Tab eventKey="10" title="Por">
                    <Tab.Content className="particle-details particle-details-dust">
                        <Row>
                            <Col lg={3} className="particle-details-data">
                                <Col lg={12} className="data-current">
                                    <i className="icon"><FontAwesomeIcon size="4x" icon={['fal', 'particles']} /></i>
                                    <p>{dustThreshold}</p>
                                    <h4>Határérték</h4>
                                </Col>
                                <Col lg={12} className="data-current" style ={{paddingBottom : '10px' , paddingTop: '10px'}}>
                                    <h4>Utolsó mérés ideje</h4>
                                    <span>{lastMeasurement.dust}</span>
                                </Col>
                                <Col lg={12} className="data-minmax">
                                    <Row>
                                        <Col lg={6} className="data-min">
                                            <i className="icon"><FontAwesomeIcon size="3x" icon={['fal', 'particles']} /></i>
                                            <p>{dustWeeklyAvg.min !== null ? parseInt(dustWeeklyAvg.min) : 0}</p>
                                        </Col>
                                        <Col lg ={6}>
                                            <i className="icon"><FontAwesomeIcon size="3x" icon={['fal', 'particles']} /></i>
                                            <p>{dustWeeklyAvg.max !== null ? parseInt(dustWeeklyAvg.max) : 0}</p>
                                        </Col>
                                    </Row>
                                    <h4>Min/Max határátlépés<br />(előző hét)</h4>
                                </Col>
                                <Col lg={12} className="data-map" role="button" onClick={()  => openCadastreOnMap()}>
                                    <i className="icon"><FontAwesomeIcon size="3x" icon={['fal', 'map-marked-alt']} /></i>
                                    <h4>Szenzorok megjelenítése a térképen</h4>
                                </Col>
                            </Col>
                            <Col lg={9} className="particle-details-chart">
                                <Row>
                                    <Col lg={12}>
                                        <MultiLineChart treshold={dustThreshold} dateType={dateType} setDateType={setDateType} data={dustDataLast5Days.length ? {min:dustDataLast5Days.map(x => x.min), max:dustDataLast5Days.map(x => x.max), avg:dustDataLast5Days.map(x => x.avg)} : []} labels={dustParse} labelName={["Max", "Min", "Átlag"]} title={"Mért adatok (Elmúlt "+ dateType + " nap)"} fill={"origin"} types={[{title:"Napi", value:1}, {title:"Heti", value:7}, {title:"Havi", value:30}]}/>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={6} md={6}>
                                        <StackedbarChart labels={weeklyParse} values={dustLimitPrevMonth} title={"Mért adatok (Előző hónapban)"}/>
                                    </Col>
                                    <Col lg={6} md={6}>
                                        <StackedbarChart labels={yearlyParse} values={[]} title={"Mért adatok"}/>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Tab.Content>
                </Tab>
                <Tab eventKey="11" title="Hőmérséklet">
                    <Tab.Content className="particle-details particle-details-temp">
                        <Row>
                            <Col lg={3} className="particle-details-data">
                                <Col lg={12} className="data-current">
                                    <i className="icon"><FontAwesomeIcon size="4x" icon={['far', 'thermometer-three-quarters']} /></i>
                                    <p>{Math.floor(temperatureDataActual)} °C</p>
                                    <h4>Aktuális hőmérséklet</h4>
                                </Col>
                                <Col lg={12} className="data-current" style ={{paddingBottom : '10px' , paddingTop: '10px'}}>
                                    <h4>Utolsó mérés ideje</h4>
                                    <span>{lastMeasurement.temperature}</span>
                                </Col>
                                <Col lg={12} className="data-minmax">
                                    <Row>
                                        <Col lg={6}>
                                            <i className="icon"><FontAwesomeIcon size="3x" icon={['far', 'temperature-low']} /></i>
                                            <p>{Math.floor(temperatureDataLastDay.min)} °C</p>
                                        </Col>
                                        <Col lg ={6}>
                                            <i className="icon"><FontAwesomeIcon size="3x" icon={['far', 'temperature-high']} /></i>
                                            <p>{Math.floor(temperatureDataLastDay.max)} °C</p>
                                        </Col>
                                    </Row>
                                    <h4>Min/Max hőmérséklet<br />(előző nap)</h4>
                                </Col>
                                <Col lg={12} className="data-map" role="button" onClick={()  => openCadastreOnMap()}>
                                    <i className="icon"><FontAwesomeIcon size="3x" icon={['fal', 'map-marked-alt']} /></i>
                                    <h4>Szenzorok megjelenítése a térképen</h4>
                                </Col>
                            </Col>
                            <Col lg={9} className="particle-details-chart">
                                <Row>
                                    <Col lg={12}>
                                        <MultiLineChart dateType={dateType} setDateType={setDateType} data={temperatureDataLast5Days.length ? {min:temperatureDataLast5Days.map(x => x.min), max:temperatureDataLast5Days.map(x => x.max), avg:temperatureDataLast5Days.map(x => x.avg)} : []} labels={temperatureParse} labelName={["Max hőmérséklet", "Min hőmérséklet", "Átlag hőmérséklet"]} title={"Hőmérséklet (Elmúlt "+ dateType + " nap)"} fill={"origin"} types={[{title:"Napi", value:1}, {title:"Heti", value:7}, {title:"Havi", value:30}]}/>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <MultiLineChart dateType={dateType} setDateType={setDateType} data={{min:[], max:[], avg:[]}} labels={monthlyParse} labelName={["Napi max átlag", "Napi min átlag", "Napi átlag"]} title={"Előző évi adatok"} fill={false} types={[]}/>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Tab.Content>
                </Tab>
                <Tab eventKey="12" title="Pára">
                    <Tab.Content className="particle-details particle-details-humadity">
                        <Row>
                            <Col lg={3} className="particle-details-data">
                                <Col lg={12} className="data-current">
                                    <i className="icon"><FontAwesomeIcon size="4x" icon={['far', 'humidity']} /></i>
                                    <p>{currentHumidity} %</p>
                                    <h4>Aktuális páratartalom</h4>
                                </Col>
                                <Col lg={12} className="data-current" style ={{paddingBottom : '10px' , paddingTop: '10px'}}>
                                    <h4>Utolsó mérés ideje</h4>
                                    <span>{lastMeasurement.humidity}</span>
                                </Col>
                                <Col lg={12} className="data-minmax">
                                    <Row>
                                        <Col lg={6}>
                                            <i className="icon"><FontAwesomeIcon size="3x" icon={['far', 'humidity']} /></i>
                                            <p>21 %</p>
                                        </Col>
                                        <Col lg ={6}>
                                            <i className="icon"><FontAwesomeIcon size="3x" icon={['far', 'humidity']} /></i>
                                            <p>72 %</p>
                                        </Col>
                                    </Row>
                                    <h4>Min/Max páratartalom<br />(előző hét)</h4>
                                </Col>
                                <Col lg={12} className="data-map" role="button" onClick={()  => openCadastreOnMap()}>
                                    <i className="icon"><FontAwesomeIcon size="3x" icon={['fal', 'map-marked-alt']} /></i>
                                    <h4>Szenzorok megjelenítése a térképen</h4>
                                </Col>
                            </Col>
                            <Col lg={9} className="particle-details-chart">
                                <Row>
                                    <Col lg={12}>
                                        <MultiLineChart dateType={dateType} setDateType={setDateType} data={humidityataLast5Days.length ? {min:humidityataLast5Days.map(x => x.min), max:humidityataLast5Days.map(x => x.max), avg:humidityataLast5Days.map(x => x.avg)} : []} labels={humidityParse} labelName={["Max Páratartalom", "Min Páratartalom", "Átlag Páratartalom"]} title={"Páratartalom (Elmúlt " + dateType + " nap)"} fill={"origin"} types={[{title:"Napi", value:1}, {title:"Heti", value:7}, {title:"Havi", value:30}]}/>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <MultiLineChart dateType={dateType} setDateType={setDateType} data={{min:[], max:[], avg:[]}} labels={monthlyParse} labelName={["Napi max átlag", "Napi min átlag", "Napi átlag"]} title={"Előző évi adatok"} fill={false} types={[]}/>
                                    </Col>
                                </Row>                            
                            </Col>
                        </Row>
                    </Tab.Content>
                </Tab>
                <Tab eventKey="13" title="Zaj">
                    <Tab.Content className="particle-details particle-details-dust">
                       {noiseData && <Row>
                            <Col lg={3} className="particle-details-data">
                                <Col lg={12} className="data-current">
                                    <i className="icon"><FontAwesomeIcon size="4x" icon={['far', 'podcast']} /></i>
                                    <p>{parseInt(noiseData.actual.measured_value).toFixed(2)} {noiseData.unit}</p>
                                    <h4>Aktuális Zaj értéke</h4>
                                </Col>
                                <Col lg={12} className="data-current" style ={{paddingBottom : '10px' , paddingTop: '10px'}}>
                                    <h4>Utolsó mérés ideje</h4>
                                    <span>{noiseData.last_measurement}</span>
                                </Col>
                                <Col lg={12} className="data-map" role="button" onClick={()  => openCadastreOnMap()}>
                                    <i className="icon"><FontAwesomeIcon size="3x" icon={['fal', 'map-marked-alt']} /></i>
                                    <h4>Szenzorok megjelenítése a térképen</h4>
                                </Col>
                            </Col>
                            <Col lg={9} className="particle-details-chart">
                                <Row>
                                    <Col lg={12}>
                                        <MultiLineChart 
                                            dateType={dateType} 
                                            data={{min:Object.values(noiseData.days).map(x => x.min), max:Object.values(noiseData.days).map(x => x.max), avg:Object.values(noiseData.days).map(x => x.avg)}} 
                                            setDateType={setDateType} 
                                            labels={Object.keys(noiseData.days)}
                                            labelName={["Maximum érték", "Minimum érték", "Átlag"]} 
                                            title={"Zaj (Elmúlt " + dateType + " nap)"} 
                                            fill={"origin"}
                                            types={[{title:"Napi", value:1}, {title:"Heti", value:7}, {title:"Havi", value:30}]}/>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <MultiLineChart dateType={dateType} setDateType={setDateType} data={{min:[], max:[], avg:[]}} labels={monthlyParse} labelName={["Napi max átlag", "Napi min átlag", "Napi átlag"]} title={"Előző évi adatok"} fill={false} types={[]}/>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>}
                    </Tab.Content>
                </Tab>
                <Tab eventKey="14" title="CO">
                    <Tab.Content className="particle-details particle-details-dust">
                        {coData && <Row>
                            <Col lg={3} className="particle-details-data">
                                <Col lg={12} className="data-current">
                                    <i className="icon"><FontAwesomeIcon size="4x" icon={['far', 'radiation']} /></i>
                                    <p>{parseInt(coData.actual.measured_value).toFixed(2)} {coData.unit}</p>
                                    <h4>Aktuális CO értéke</h4>
                                </Col>
                                <Col lg={12} className="data-current" style ={{paddingBottom : '10px' , paddingTop: '10px'}}>
                                    <h4>Utolsó mérés ideje</h4>
                                    <span>{coData.last_measurement}</span>
                                </Col>
                                <Col lg={12} className="data-map" role="button" onClick={()  => openCadastreOnMap()}>
                                    <i className="icon"><FontAwesomeIcon size="3x" icon={['fal', 'map-marked-alt']} /></i>
                                    <h4>Szenzorok megjelenítése a térképen</h4>
                                </Col>
                            </Col>
                            <Col lg={9} className="particle-details-chart">
                                <Row>
                                    <Col lg={12}>
                                        <MultiLineChart 
                                            dateType={dateType} 
                                            data={{min:Object.values(coData.days).map(x => x.min), max:Object.values(coData.days).map(x => x.max), avg:Object.values(coData.days).map(x => x.avg)}}
                                            setDateType={setDateType}
                                            labels={Object.keys(coData.days)}
                                            labelName={["Maximum érték", "Minimum érték", "Átlag"]} 
                                            title={"CO (Elmúlt " + dateType + " nap)"} 
                                            fill={"origin"} 
                                            types={[{title:"Napi", value:1}, {title:"Heti", value:7}, {title:"Havi", value:30}]}/>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <MultiLineChart dateType={dateType} setDateType={setDateType} data={{min:[], max:[], avg:[]}} labels={monthlyParse} labelName={["Napi max átlag", "Napi min átlag", "Napi átlag"]} title={"Előző évi adatok"} fill={false} types={[]}/>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>}
                    </Tab.Content>
                </Tab>
            </Tabs>
        </div>
    );
}

const mapStateToProps = state => ({
    layerOptions: getMapLayerOptions(state),
    cadastreData : getUserCadastreData(state),

});

const mapDispatchToProps = (dispatch) => ({
    addLayer: (selected) => {
        dispatch(setAllLoadedLayers(selected));
    },
    updateLoadedDynamicCadastreLayers: (cadastre) => {
		dispatch(updateLoadedDynamicCadastreLayers(cadastre))
	},
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(EnvironmentDetails);
